import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Icon,
  styled,
} from '@nextiva/next-ui-components';

export const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    min-width: 670px;
  }
`;
export const StyledDialogTitle = styled(DialogTitle)`
  margin: 34px 0px 34px 0px;
`;
export const StyledDialogActions = styled(DialogActions)`
  margin-bottom: 30px;
`;
export const StyledCancelButton = styled(Button)`
  margin-right: 8px;
`;
export const StyledDividerContainer = styled('div')`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;
export const StyledDivider = styled('div')`
  height: 1px;
  border-top: 1px solid;
  border-color: ${({ theme }) => theme.palette.secondary.main};
  width: 90%;
`;
export const StyledDialogContent = styled(DialogContent)`
  margin-bottom: 32px;
`;
export const StyledTitleIcon = styled(Icon)`
  margin: 0px 0px 5px 12px;
  fill: #758ba3;
  transform: scale(1.4);
`;
export const StyledContentDividerContainer = styled('div')`
  display: flex;
  justify-content: center;
  margin: 24px 0px 32px 0px;
`;
export const StyledContentDivider = styled('div')`
  height: 2px;
  border-top: 2px solid;
  border-color: ${({ theme }) => theme.palette.secondary.main};
  width: 100%;
`;
export const StyledPaymentContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;
export const StyledPaymentAlert = styled(Alert)`
  width: 100%;
  margin: -8px 0px 24px 0px;
  align-items: center;
`;
export const StyledPaymentText = styled('div')`
  text-decoration: underline;
  cursor: pointer;
`;
export const StyledChatLink = styled('a')`
  text-decoration: underline;
`;
export const StyledLoadingSpinnerContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 768px;
  height: 727px;
`;
